import { useApiQuery } from '../useApiQuery'

export const useGetCurrentSociogram = () => {
  const query = useApiQuery(
    ['currentSociogram'],
    'sociogram',
    '/sociograms/organization/current'
  )

  return {
    isLoadingCurrentSociogram: query.isLoading,
    isFetchingCurrentSociogram: query.isFetching,
    dataCurrentSociogram: query.data || null,
    errorCurrentSociogram: query.error,
    getData: query.refetch
  }
}
